import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import type { ISmartCallFlowForwardCallStepNumber } from 'entities/SmartCall/api/types'
import { TextToSpeechWidgetStore } from 'widgets/TextToSpeech'

export class NumberWhisperStore {
  readonly textToSpeechWidgetStore: TextToSpeechWidgetStore
  constructor(
    private _entities: IEntitiesStore,
    readonly initConfig?: ISmartCallFlowForwardCallStepNumber['whisperConfig']
  ) {
    this._active = initConfig?.active || false
    this.textToSpeechWidgetStore = new TextToSpeechWidgetStore(
      {
        type: 'view',
        message: initConfig?.text || '',
        voiceId: initConfig?.voiceId || '',
      },
      this._entities
    )
    makeAutoObservable(this)
  }

  get params(): ISmartCallFlowForwardCallStepNumber['whisperConfig'] {
    return {
      active: this._active,
      voiceId: this.textToSpeechWidgetStore.params.voiceId,
      text: this.textToSpeechWidgetStore.params.text,
    }
  }

  validate = () => {
    let valid = true
    if (this.active) {
      if (!this.params.text) {
        this.textToSpeechWidgetStore.setValidError('A short message should not be empty')
        valid = false
      }
    }

    return valid
  }

  get error() {
    return this.textToSpeechWidgetStore.error
  }

  private _active: boolean
  get active() {
    return this._active
  }
  setActive = (active: boolean) => {
    if (!active) {
      this.textToSpeechWidgetStore.setValidError('')
    }
    this._active = active
  }
  reset = () => {
    this._active = false
    this.textToSpeechWidgetStore.reset()
  }
}
